// extracted by mini-css-extract-plugin
export var ALERT = "notification-alert-module--ALERT--757f9";
export var INFO = "notification-alert-module--INFO--32726";
export var container = "notification-alert-module--container--c5fe1";
export var content = "notification-alert-module--content--133cb";
export var errorIcon = "notification-alert-module--errorIcon--3754d";
export var hide = "notification-alert-module--hide--7f065";
export var show = "notification-alert-module--show--fe209";